import DepsService from 'services/dependencies';

const CONTEXT = 'downloadReportsPack';

export const downloadReportsPack = (token) => {
  const url = DepsService.rest.reports.zip.subscriptions.url;
  const queryParams = {};
  const urlParams = { token };

  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/download-report-page/download-report-page.api.js